import React from 'react';
import {
    // Navigate,
    BrowserRouter as Router,
    useRoutes
} from 'react-router-dom';
import Welcome from '../pages/Welcome';   
import Login from '../pages/auth/Login';
import Signup from '../pages/auth/Signup';
import ForgotPass from '../pages/auth/ForgotPass';
import Home from '../pages/Home/Index';
import ReturnList from '../pages/ReturnList';
import UserDetails from '../pages/UserDetails';
import TaxFileDetail from '../pages/executive/TaxFileDetails';
import TaxFileList from '../pages/executive/TaxFileList';
import AddTemplate from '../pages/executive/AddTemplate';
import TemplateList from '../pages/executive/TemplateList';
import ExecutiveList from '../pages/executive/ExecutiveList';
import AddExecutive from '../pages/executive/AddExecutive';
import ChatWindowComponent from '../pages/executive/Messages';
import MessagesList from '../pages/executive/MessagesList';
import ChatFloor from '../BTUI/BtChat';
import NrcPaymentRequests from '../pages/executive/NrcPaymentRequests';
// import ErrorPage from '../pages/ErrorPage.js'
// import { Layout as LayoutYR22 } from '../YR22/pages/Layout.js';
// import {Layout as LayoutYR23 } from '../YR23/pages/Layout.js'
// import LoginLayout from '../pages/login/LoginLayout.js';
// import Login from '../pages/login/index.js';
// import SignUp from '../pages/login/SignUp.js';
// import UserLayout from '../pages/User/UserLayout.js'
// import HomeLayout from '../pages/HomeLayout/index.js'
// import Home from '../pages/home/index.js'
// import UserHome from '../pages/User/UserHome.js';
// import Test from '../pages/Test.js';
// import routesYR22 from './routesYR22.js';
// import routesYR23 from './routesYR23.js';
// import CraAutoFillHandler from '../pages/afr/CraAutoFillHandler.js';




const AllRoutes = () => {
    // const isLoggedIn = localStorage.getItem('token')
    const routes = [
        // {path:'',element:<Welcome/>},
        // {path:'welcome',element:<Welcome/>},
        {path:'',element:<Login/>},
        {path:'login',element:<Login/>},
        // {path:'signup',element:<Signup/>},
        {path:'reset',element:<ForgotPass/>},
        {path:'home',element:<ReturnList/>},
        // {path:'details/:id',element:<UserDetails/>},
        {path: 'executive',
            children:[
                {index:true, element : <TaxFileList />},
                {path:'list',element:<ExecutiveList/>},
                {path:'nrc-payment-requests',element:<NrcPaymentRequests/>},
                {path:'messages',element:<MessagesList/>},
                // {path:'chatfloor',element:<ChatFloor/>},
                {path:'message/:id',element:<ChatWindowComponent/>},
                {path:'add',element:<AddExecutive/>},
                {path:'taxfile/:id', element : <TaxFileDetail/>},
                {path:'taxfile',element:<TaxFileList/>},
                {path:'template/add',element:<AddTemplate/>},
                {path:'template/list',element:<TemplateList/>},
            ]
    },

        { path: '*', element: <h1>error</h1> }
    ]
    return useRoutes(routes);
}

const BtRouter = () => {
    return (
        <Router basename='/'>
            <AllRoutes />
        </Router>

    )
}

export default BtRouter